import { DYNAMIC_FORM } from '../endpoints';
import request from '../request';

export const getFormStructure = (id: string | number) => {
  const url = DYNAMIC_FORM.STRUCTURE(id);
  return request<any>(url);
};
